"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _Icon = require("b2b-components/theme/components/Icon");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _ButtonIcon = require("./ButtonIcon.types");
require("./ButtonIcon.scss");
const ButtonIcon = _ref => {
  let {
    icon,
    className,
    size = _ButtonIcon.BUTTON_ICON_SIZE.default,
    iconClassName,
    ...props
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-ButtonIcon', {
    [`cds-ButtonIcon--${(0, _upperCase.upperCaseFirst)(size || '')}`]: size !== _ButtonIcon.BUTTON_ICON_SIZE.default
  }, className);
  return /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({}, props, {
    size: _Button.BUTTON_SIZE.default,
    className: rootClassName
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: icon,
    className: (0, _classnames.default)(iconClassName, 'cds-ButtonIcon-Icon')
  }));
};
exports.ButtonIcon = ButtonIcon;
//# sourceMappingURL=ButtonIcon.js.map